import styles from "./Body.module.scss";

interface BodyProps {
  title?: string;
  subtitle?: string;
  isLoading?: boolean;
  children: React.ReactNode;
}

const Body = ({ title, subtitle, children }: BodyProps) => {
  return (
    <>
      <div className={styles.content}>
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.subtitle}>{subtitle}</p>
      </div>

      <div>{children}</div>
    </>
  );
};

export default Body;
